import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import DSButton from "../../views/system-design/DSButton";
import DSCircularProgress from "../../views/system-design/DSCircularProgress";

const variantToColor: Record<
  string,
  "primary" | "secondary" | "error" | "warning" | "info" | "success"
> = {
  primary: "primary",
  secondary: "secondary",
  danger: "error",
  warning: "warning",
  info: "info",
  success: "success",
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ButtonLoader = (props: any) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const setE = () => {
    setError(true);
    setTimeout(() => {
      setError(false);
    }, 5000);
  };
  const { title, variant, loading: externalLoading, ...rest } = props;
  void externalLoading;
  return (
    <DSButton
      variant="contained"
      color={variantToColor[variant as string] ?? "primary"}
      {...rest}
      onClick={
        loading
          ? undefined
          : () => {
              setLoading(true);
              props
                .onClick()
                .catch(setE)
                .finally(() => setLoading(false));
            }
      }
    >
      <>
        {loading && (
          <DSCircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
        )}
        {error && <CloseIcon fontSize="small" sx={{ mr: 0.5 }} />}
        {title}
      </>
    </DSButton>
  );
};
export default ButtonLoader;
